import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const IconResidence = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.8251 18.9584H5.17508C2.89175 18.9584 1.04175 17.1001 1.04175 14.8167V8.64173C1.04175 7.50839 1.74175 6.08339 2.64175 5.38339L7.13342 1.88339C8.48342 0.833393 10.6417 0.783393 12.0417 1.76673L17.1917 5.37506C18.1834 6.06673 18.9584 7.55006 18.9584 8.75839V14.8251C18.9584 17.1001 17.1084 18.9584 14.8251 18.9584ZM7.90008 2.86673L3.40841 6.36673C2.81675 6.83339 2.29175 7.89173 2.29175 8.64173V14.8167C2.29175 16.4084 3.58342 17.7084 5.17508 17.7084H14.8251C16.4167 17.7084 17.7084 16.4167 17.7084 14.8251V8.75839C17.7084 7.95839 17.1334 6.85006 16.4751 6.40006L11.3251 2.79173C10.3751 2.12506 8.80841 2.15839 7.90008 2.86673Z"
          fill={color}
        />
        <path
          d="M10.0001 15.6251C9.65841 15.6251 9.37508 15.3417 9.37508 15.0001V12.5001C9.37508 12.1584 9.65841 11.8751 10.0001 11.8751C10.3417 11.8751 10.6251 12.1584 10.6251 12.5001V15.0001C10.6251 15.3417 10.3417 15.6251 10.0001 15.6251Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
